module.exports = __webpack_public_path__ + "img/shopifyicon.a38e0402.svg";